"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var YotpoStar_1 = require("./YotpoStar");
var CloseBtn_1 = require("../common/Btn/CloseBtn");
var yotpo_img_1 = require("../../constants/img/yotpo-img");
var YotpoSearchTerm = function (_a) {
    var _b, _c;
    var searchParams = _a.searchParams, setSearchParams = _a.setSearchParams, setQueryParams = _a.setQueryParams;
    // Remove rating filter on close button
    var removeFilterByScore = function () {
        setSearchParams(function (prev) { return (__assign(__assign({}, prev), { scores: [] })); });
        // Reset pagination to the first page
        setQueryParams({ page: 1 });
    };
    // TODO: handle to call this only after some delay by users
    // TODO: ref: https://css-tricks.com/debouncing-throttling-explained-examples/
    // Search string using API's param free_text_search
    var handleSearch = function (event) {
        event.preventDefault();
        if (event.target) {
            setSearchParams(function (prev) { return (__assign(__assign({}, prev), { free_text_search: event.currentTarget.value })); });
            // Reset pagination to the first page
            setQueryParams({ page: 1 });
        }
    };
    return ((0, preact_1.h)("div", { class: "yotpo-search" },
        (0, preact_1.h)("div", { class: "yotpo-search__input-wrapper" },
            (0, preact_1.h)("img", { class: "yotpo-search__input-icon", src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/search-icon.png?v=1710288260" }),
            (0, preact_1.h)("input", { type: "search", placeholder: "SEARCH", onChange: handleSearch, value: searchParams.free_text_search, class: "yotpo-search__input" })),
        ((_b = searchParams.scores) === null || _b === void 0 ? void 0 : _b.length) !== 0 && ((0, preact_1.h)("div", { class: "yotpo-search__content" },
            (0, preact_1.h)(YotpoStar_1.default, { score: ((_c = searchParams === null || searchParams === void 0 ? void 0 : searchParams.scores) === null || _c === void 0 ? void 0 : _c.at(0)) || 0, id: "yotpo-review-filter-star", size: "small", color: "#2d2926", starFilledImg: yotpo_img_1.YOTPO_STAR_FILLED_BLACK, starOutlinedImg: yotpo_img_1.YOTPO_STAR_OUTLINED_BLACK }),
            (0, preact_1.h)(CloseBtn_1.default, { closeFn: removeFilterByScore })))));
};
exports.default = YotpoSearchTerm;
